// import chroma from "chroma-js"

const gray = {
  900: "#707070",
  800: "#9D9D9D",
  700: "#A7A7A7",
  600: "#C3C3C3",
  500: "#D6D6D6",
  400: "#E6E6E6",
  300: "#f0f0f0",
  200: "#f5f5f5",
  150: "#eff0f3",
  100: "#fafafa",
}

// Fifty Shades Darker
const darkThemeGray = {
  900: "#202020",
  800: "#303030",
  700: "#424242",
  600: "#626262",
  500: "#757575",
  400: "#8F8F8F",
  300: "#ABABAB",
  200: "#C2C2C2",
  100: "#DBDBDB",
}

const primaryColor = "#006169"
const primaryLight = "#F2FAFA"
const primaryHover = "#006169"
const primaryGreen = "#28B16D"
const primaryGreenLight = "#f0faf5"
const accentColor = "#0091ba"
const accentColorAlt = "#00A4d1"
const accentColorLight = "#E6F5F9"
const linkColor = primaryColor
const linkHover = "#0D79DF"
const warningColor = "#FFC107"
const warningHover = "#EDAD02"
const errorColor = "#e83a3a"
const errorColorLight = "#fef2f2"
const baseColor = "#000"
const tooltipBg = "#fff"

const sliderRailColor = "rgba(95,99,242,0.2)"
const borderColorBase = gray[300]
const btnBorderColor = gray[500]
const searchIconSpace = "24px"

// Font weight constants
const fwNormal = 400
const fwMedium = 500
const fwSemibold = 600
const fwBold = 700

const gray100 = gray[100]
const gray150 = gray[150]
const gray200 = gray[200]
const gray300 = gray[300]
const gray400 = gray[400]
const gray500 = gray[500]
const gray600 = gray[600]
const gray700 = gray[700]
const gray800 = gray[800]
const gray900 = gray[900]

const darkThemeGray800 = darkThemeGray[800]
const darkThemeGray700 = darkThemeGray[700]
const darkThemeGray600 = darkThemeGray[600]
const darkThemeGray500 = darkThemeGray[500]
const darkThemeGray400 = darkThemeGray[400]
const darkThemeGray300 = darkThemeGray[300]
const darkThemeGray200 = darkThemeGray[200]
const darkThemeGray100 = darkThemeGray[100]

const themeVariables = {
  gray100,
  gray150,
  gray200,
  gray300,
  gray400,
  gray500,
  gray600,
  gray700,
  gray800,
  gray900,
  darkThemeGray800,
  darkThemeGray700,
  darkThemeGray600,
  darkThemeGray500,
  darkThemeGray400,
  darkThemeGray300,
  darkThemeGray200,
  darkThemeGray100,

  "primary-color": primaryColor,
  "primary-hover": primaryHover,
  "primary-light": primaryLight,
  "primary-green": primaryGreen,
  "primary-green-light": primaryGreenLight,
  "accent-color": accentColor,
  "accent-color-alt": accentColorAlt,
  "accent-color-light": accentColorLight,
  "link-color": linkColor,
  "link-hover": linkHover,
  "warning-color": warningColor,
  "warning-hover": warningHover,
  "error-color": errorColor,
  "error-color-light": errorColorLight,
  "base-color": baseColor,
  // "font-family": "'Lato', Helvetica, sans-serif",
  "font-family": "'Droid Arabic Kufi', sans-serif",
  "text-color-secondary": gray[900],
  "disabled-color": "rgba(0, 0, 0, 0.25)",
  "border-radius-base": "4px",
  "border-color-base": borderColorBase,
  "border-color-light": gray[500],
  "box-shadow-base": "0 2px 8px rgba(0, 0, 0, 0.15)",
  "border-color-normal": borderColorBase,
  "btn-border-color": btnBorderColor,
  "search-icon-space": searchIconSpace,

  // Font weights
  "fw-normal": fwNormal,
  "fw-medium": fwMedium,
  "fw-semibold": fwSemibold,
  "fw-bold": fwBold,

  // >>> Success
  "success-color": primaryColor,

  // Heading
  fontSizeHeading1: "24px",
  fontSizeHeading2: "22px",
  "heading-2-size": "22px",
  "heading-3-size": "18px",
  "heading-4-size": "16px",
  "heading-5-size": "14px", // not recommended in guideline

  // Cards
  "card-head-background": "#fff",
  "card-background": "#fff",
  "card-radius": "4px",

  // Layout
  "layout-body-background": "#f6f7fb",
  "layout-header-background": "#fff",
  "layout-footer-background": "#fafafa",
  "layout-header-padding": "0 30px 0 15px",
  "layout-footer-padding": "24px 15px",
  "layout-sider-background": "#fff",
  "layout-trigger-height": "48px",
  "layout-trigger-background": "#002140",
  "layout-trigger-color": "#fff",
  "layout-zero-trigger-width": "36px",
  "layout-zero-trigger-height": "42px",

  // Form
  "label-required-color": errorColor,
  "label-color": gray[900],
  "form-item-margin-bottom": "18px",
  "form-item-label-font-size": "14px",

  // Buttons
  "btn-border-width": 0,
  "btn-default-bg": gray[100],
  "btn-height-base": "40px",
  "btn-height-lg": "44px",
  "btn-height-sm": "36px",
  "btn-padding-horizontal-lg": "32px",
  "btn-padding-horizontal-sm": "16px",
  "btn-circle-size": "32px",
  "btn-circle-size-lg": "40px",
  "btn-circle-size-sm": "24px",
  "btn-square-size": "32px",
  "btn-square-size-lg": "40px",
  "btn-square-size-sm": "24px",
  linkHoverBg: primaryHover,

  // Alert
  // ---
  "alert-warning-icon-color": "@warning-color",
  "alert-message-color": "currentColor",

  // radio btn
  "radio-button-checked-bg": primaryColor,

  // Checkbox
  "checkbox-color": accentColorAlt,
  "checkbox-border-radius": "2px",

  // gutter width
  "grid-gutter-width": 25,

  // Tree
  // ---
  "tree-node-selected-bg": "transparent",

  // slider
  "slider-rail-background-color": sliderRailColor,
  "slider-rail-background-color-hover": sliderRailColor,
  "slider-track-background-color": primaryColor,
  "slider-track-background-color-hover": primaryColor,
  "slider-handle-color": primaryColor,
  "slider-handle-size": "16px",

  // input
  "input-height-base": "48px",
  "input-border-color": borderColorBase,
  "input-height-sm": "30px",
  "input-height-lg": "50px",
  "input-placeholder-color": gray[700],
  "input-color": baseColor,

  // Select
  "select-item-selected-color": primaryColor,
  "select-item-selected-bg": primaryLight,
  "select-selection-item-bg": primaryLight,

  // rate
  "rate-star-color": warningColor,
  "rate-star-size": "13px",

  // Switch
  "switch-min-width": "35px",
  "switch-sm-min-width": "30px",
  "switch-height": "18px",
  "switch-sm-height": "15px",

  // result
  "result-title-font-size": "20px",
  "result-subtitle-font-size": "12px",
  "result-icon-font-size": "50px",

  // tabs
  "tabs-horizontal-padding": "12px 8px",
  "tabs-horizontal-padding-lg": "12px 16px",
  "tabs-horizontal-gutter": "16px",
  "tabs-bar-margin": "16px 0",

  "tabs-title-font-size": "14px",
  "tabs-title-font-size-lg": "14px",
  "tabs-title-font-size-sm": "14px",

  "tabs-ink-bar-color": accentColor,
  "tabs-highlight-color": accentColor,
  "tabs-hover-color": accentColorAlt,
  // "tabs-active-color": chroma(accentColor).darken(0.8),

  // list
  "list-item-padding": "10px 24px",
  "list-item-padding-sm": "8px 0",

  // Tags
  "tag-border-radius": "4px",
  "tag-default-bg": gray[150],
  "tag-line-height": "24px",

  // Table
  "table-font-size": "inherit",
  "table-header-bg": gray[200],
  "table-header-color": gray[900],
  "table-header-cell-split-color": gray[200],
  "table-padding-vertical": "8px",
  "table-padding-horizontal": "8px",
  "table-body-selected-sort-bg": gray[100],
  "table-selected-row-bg": "transparent",
  "table-row-hover-bg": gray[300],

  // Badge
  "@badge-dot-size": "10px",

  // Tooltip
  "tooltip-color": "#000",
  "tooltip-bg": tooltipBg,
  "tooltip-arrow-color": tooltipBg,

  // Modals
  "modal-header-bg": gray[200],
  "modal-header-padding-vertical": "20px",
  "modal-header-padding-horizontal": "32px",
  "modal-header-title-font-size": "18px",
  "modal-body-padding": "16px 32px",
  "modal-footer-padding-horizontal": "32px",
  "modal-footer-padding-vertical": "20px",

  // Segmented
  "segmented-bg": "#fff",
  "segmented-hover-bg": "#fff",
  "segmented-selected-bg": primaryLight,
  "segmented-label-color": gray[600],
  "segmented-label-hover-color": primaryColor,

  // Pagination
  "pagination-item-size": "36px",
  "pagination-font-weight-active": "600",
  "pagination-item-bg-active": primaryLight,
  "pagination-item-input-bg": "black",

  // Statistic
  "statistic-content-font-size": "1rem",

  // Drawer
  // ---
  "drawer-header-padding": "30px 24px 12px",
  "drawer-title-font-size": "20px",
  "drawer-title-line-height": "28px",

  // The background colors for active and hover states for things like
  // list items or table cells.
  "item-active-bg": primaryLight,

  // TimePicker
  "picker-basic-cell-active-with-range-color": primaryLight,
  "picker-date-hover-range-border-color": primaryColor,
  "picker-date-hover-range-color": "#fff",
}

export default { variables: themeVariables }
